import { createRouter, createWebHistory } from 'vue-router'
import Login from '@/views/login/Main.vue'

import Recovery from '@/views/recovery-password/Main.vue'
import ResetPassword from '@/views/reset-password/Main.vue'

import Activate from '@/views/activate/Main.vue'
import Otp from '@/views/otp/Main.vue'

import Terms from '@/views/terms-conditions/Main.vue'
import Privacity from '@/views/privacity/Main.vue'
import Contact from '@/views/contact/Main.vue'
import Help from '@/views/help/Main.vue'

import Home from '@/views/home/Main.vue'
import MyProfile from '@/views/my-profile/Main.vue'
import Catalogue from '@/views/catalogue/Main.vue'
import QuotationEmpty from '@/views/quotations/quotation-empty/Main.vue'
import Quotations from '@/views/quotations/my-quotations/Main.vue'
import Products from '@/views/catalogue/products/Main.vue'
import Favorites from '@/views/favorites/Main.vue'
import Cart from '@/views/cart/Main.vue'

import { useStore } from '@/store'

// GUARDS

const cleanGlobal = () => cash('html').removeClass()
const store = useStore()

const isUnauthenticated = (_to, _from, next) => {
  cleanGlobal()
  if (!store.state.auth.token || !store.state.auth.user) {
    next('/login')
  } else {
    next()
  }
}

const isAuth = (_to, _from, next) => {
  cleanGlobal()
  if (store.state.auth.token && store.state.auth.user) {
    next('/')
  } else {
    next()
  }
}

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    beforeEnter: isAuth,
    meta: {
      title: 'Iniciar sesión'
    }
  },
  {
    path: '/recovery',
    name: 'recovery',
    component: Recovery,
    beforeEnter: isAuth,
    meta: {
      title: 'Recuperar contraseña'
    }
  },
  {
    path: '/reset-password/:email/:otp',
    name: 'reset-password',
    component: ResetPassword,
    beforeEnter: isAuth,
    meta: {
      title: 'Cambiar contraseña'
    }
  },
  {
    path: '/activate',
    name: 'activate',
    component: Activate,
    beforeEnter: isAuth,
    meta: {
      title: 'Activar cuenta'
    }
  },
  {
    path: '/otp/:email',
    name: 'otp',
    component: Otp,
    beforeEnter: isAuth,
    meta: {
      title: 'Validar cuenta'
    }
  },
  {
    path: '/conditions',
    name: 'conditions',
    component: Terms,
    meta: {
      title: 'Terminos y condiciones'
    }
  },
  {
    path: '/privacity',
    name: 'privacity',
    component: Privacity,
    meta: {
      title: 'Aviso de privacidad'
    }
  },
  {
    path: '/contact',
    name: 'contact',
    component: Contact,
    beforeEnter: isUnauthenticated,
    meta: {
      title: 'Contacto'
    }
  },
  {
    path: '/help',
    name: 'help',
    component: Help,
    beforeEnter: isUnauthenticated,
    meta: {
      title: 'Preguntas frecuentes'
    }
  },
  {
    path: '/',
    name: 'home',
    component: Home,
    beforeEnter: isUnauthenticated,
    meta: {
      title: 'Página Principal'
    }
  },
  {
    path: '/catalogue/:categoryId?',
    name: 'catalogue',
    beforeEnter: isUnauthenticated,
    component: Catalogue,
    meta: {
      title: 'Catálogo de Productos'
    }
  },
  {
    path: '/quotations',
    name: 'quotations',
    beforeEnter: isUnauthenticated,
    component: Quotations,
    meta: {
      title: 'Mis cotizaciones'
    }
  },
  {
    path: '/products/:id',
    name: 'products',
    beforeEnter: isUnauthenticated,
    component: Products,
    meta: {
      title: 'Detalle del producto'
    }
  },
  {
    path: '/my-profile',
    name: 'my-profile',
    beforeEnter: isUnauthenticated,
    component: MyProfile,
    meta: {
      title: 'Mi Perfil'
    }
  },
  {
    path: '/favorites',
    name: 'favorites',
    beforeEnter: isUnauthenticated,
    component: Favorites,
    meta: {
      title: 'Mis Favoritos'
    }
  },
  {
    path: '/cart',
    name: 'cart',
    beforeEnter: isUnauthenticated,
    component: Cart,
    meta: {
      title: 'Carrito de cotizaciones'
    }
  },
  {
    path: '/quotation/:id',
    name: 'quotation',
    component: QuotationEmpty,
    beforeEnter: isUnauthenticated,
    meta: {
      title: 'Detalle de cotización'
    }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(_to, _from, savedPosition) {
    return savedPosition || { left: 0, top: 0 }
  }
})
const DEFAULT_TITLE = 'Cotizador Brandin - Seller'
router.afterEach((to) => (document.title = to.meta?.title || DEFAULT_TITLE))
export default router
